export default __webpack_public_path__ + "static/media/url_share.03e0286b.svg";